import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deletePaymentDraft,
  fetchPayment,
  fetchPaymentForCC,
  getPaymentDrafts,
  savePaymentDraft
} from "../../../services/paymentService";
import { getPaymentHistoryThunk } from "../thunks/customerThunks";
const initialState = {
  paymentdeatils: [],
  paymentForCC: null,
  paymentHistory: [], // New State
  selectedInvoicesForPayment: [],
  loading: false,
  error: null,
  showCustomerData: true,
  // Draft Management State
  drafts: [],
  isDraftsModalOpen: false,
  draftLoading: false,
  draftError: null
};

export const getPayment = createAsyncThunk(
  "/CustomerPayment",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchPayment();
      return response;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getPaymentForcc = createAsyncThunk(
  "/CustomerPaymentForCC",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchPaymentForCC(id);
      return response; // adapt if your apiClient returns { data: [...] }
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// getCustomerPaymentReference Thunk Removed

// Draft Thunks
export const saveDraftThunk = createAsyncThunk(
  "payment/saveDraft",
  async (draftData, { rejectWithValue }) => {
    try {
      const response = await savePaymentDraft(draftData);
      return response; // Assumes response is the saved draft object
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const getDraftsThunk = createAsyncThunk(
  "payment/getDrafts",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getPaymentDrafts(userId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const deleteDraftThunk = createAsyncThunk(
  "payment/deleteDraft",
  async (id, { rejectWithValue }) => {
    try {
      await deletePaymentDraft(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const PaymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    updateCustomer(state, action) {
      // This reducer seems to be for 'customers' array which is not in this slice's state.
      // Assuming it was intended for a different slice or needs adjustment.
      // Keeping it as is, but noting potential inconsistency.
      const index = state.customers.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.customers[index] = action.payload;
      }
    },
    addCustomer: (state, action) => {
      // Similar to updateCustomer, 'customers' array is not in this slice's state.
      state.customers.push(action.payload);
    },
    setSelectedInvoicesForPayment: (state, action) => {
      state.selectedInvoicesForPayment = action.payload;
    },
    // Draft Management Reducers
    setDraftsModalOpen: (state, action) => {
      state.isDraftsModalOpen = action.payload;
    },
    // Updated Reducers
    setPaymentHistory: (state, action) => {
      state.paymentHistory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Roles
      .addCase(getPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentdeatils = action.payload;
      })
      .addCase(getPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPaymentForcc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentForcc.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentForCC = action.payload;
      })
      .addCase(getPaymentForcc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getCustomerPaymentReference Handlers Removed
      .addCase(getPaymentHistoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentHistoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentHistory = action.payload; // Correctly store in paymentHistory
      })
      .addCase(getPaymentHistoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Draft Thunk Handlers
      .addCase(saveDraftThunk.pending, (state) => { state.draftLoading = true; state.draftError = null; })
      .addCase(saveDraftThunk.fulfilled, (state, action) => {
        state.draftLoading = false;
        // Check if draft already exists to avoid duplicates in UI
        const index = state.drafts.findIndex(d => d.id === action.payload.id);
        if (index !== -1) {
            // Update existing (and move to top if needed, but simple update is fine for now)
            state.drafts[index] = action.payload;
            // Optional: Move to top
            const updatedDraft = state.drafts.splice(index, 1)[0];
            state.drafts.unshift(updatedDraft);
        } else {
            state.drafts = [action.payload, ...state.drafts];
        }
      })
      .addCase(saveDraftThunk.rejected, (state, action) => { state.draftLoading = false; state.draftError = action.payload; })

      .addCase(getDraftsThunk.pending, (state) => { state.draftLoading = true; state.draftError = null; })
      .addCase(getDraftsThunk.fulfilled, (state, action) => {
        state.draftLoading = false;
        state.drafts = action.payload;
      })
      .addCase(getDraftsThunk.rejected, (state, action) => { state.draftLoading = false; state.draftError = action.payload; })

      .addCase(deleteDraftThunk.pending, (state) => { state.draftLoading = true; state.draftError = null; })
      .addCase(deleteDraftThunk.fulfilled, (state, action) => {
        state.draftLoading = false;
        state.drafts = state.drafts.filter(d => d.id !== action.payload);
      })
      .addCase(deleteDraftThunk.rejected, (state, action) => { state.draftLoading = false; state.draftError = action.payload; });
  },
});

// Exporting actions
export const {
  updateCustomer,
  addCustomer,
  setSelectedInvoicesForPayment,
  setPaymentHistory,
  setDraftsModalOpen
} = PaymentSlice.actions;

export default PaymentSlice.reducer;

